import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isAutheticated } from "../Components/auth/authhelper";
import { useUser } from "../Components/UserContext/UserProvider";

// const PrivateRoute = ({ component: Component, ...rest }) => {
//   // console.log("permission", isAutheticated)
//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         isAutheticated() ? (
//           <Component {...props} />
//         ) : (
//           <Redirect
//             to={{
//               pathname: "/",
//               state: { from: props.location },
//             }}
//           />
//         )
//       }
//     />
//   );
// };

// export default PrivateRoute;




const PrivateRoute = ({ component: Component, requiredPermission, ...rest }) => {
  const { type, token } = isAutheticated()
  const { userData } = useUser();

  return (
    <Route
      {...rest}
      render={(props) => {
        const auth = isAutheticated(); // Example: { role: "admin", permissions: { Videos: true, Analytics: false } }

        if (!token) {
          // Not logged in
          return (
            <Redirect
              to={{ pathname: "/", state: { from: props.location } }}
            />
          );
        }

        // ✅ If admin, allow all routes
        if (type === "admin") {
          return <Component {...props} />;
        }

        // ✅ If staff, check permissions
        if (requiredPermission && !userData?.permissions?.[requiredPermission]) {
          return (
            <Redirect
              to={{ pathname: "/not-allowed", state: { from: props.location } }}
            />
          );
        }

        // ✅ Allowed
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;

